<div class="page-container">
  <div class="d-none d-lg-block">
    <p-panel styleClass="no-padding">
      <p-table
        [value]="actionItemLoads"
        #table
        styleClass="p-datatable-no-border"
        [loading]="loading"
        selectionMode="single"
        [paginator]="true"
        [rows]="50"
        [rowsPerPageOptions]="[10, 25, 50, 100]"
        [first]="first"
        (onPage)="onPage($event)"
        [lazy]="lazy"
        [totalRecords]="totalRecords"
        (onLazyLoad)="onLazyLoad($event)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th [pSortableColumn]="'actionItemCount'">
              Counter Offers
              <p-sortIcon [field]="'actionItemCount'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'actionItemStatus'">
              Action Item Status
              <p-sortIcon [field]="'actionItemStatus'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'counterOfferRate'">
              Counter Offer
              <p-sortIcon [field]="'counterOfferRate'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'lineHaulRate'">
              Total Rate
              <p-sortIcon [field]="'lineHaulRate'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'counterOfferExpirationDate'">
              Expires
              <p-sortIcon [field]="'counterOfferExpirationDate'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'equipmentCategoryId'">
              Equipment
              <p-sortIcon [field]="'equipmentCategoryId'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'equipmentTypeDisplay'">
              Equipment Detail
              <p-sortIcon [field]="'equipmentTypeDisplay'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'mostRecentOfferUserName'">
              <span *ngIf="!isShipper">Requested By</span>
              <span *ngIf="isShipper">Assigned To</span>
              <p-sortIcon [field]="'mostRecentOfferUserName'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'originCity'">
              Origin
              <p-sortIcon [field]="'originCity'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'destCity'">
              Destination
              <p-sortIcon [field]="'destCity'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'originLateDtTm'">
              Pickup
              <p-sortIcon [field]="'originLateDtTm'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'destLateDtTm'">
              Delivery
              <p-sortIcon [field]="'destLateDtTm'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'referenceLoadDisplay'">
              Shipper’s Order Number
              <p-sortIcon [field]="'referenceLoadDisplay'"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-actionItemLoad let-rowIndex="rowIndex">
          <tr (click)="onRowSelect(actionItemLoad)" [pSelectableRow]="actionItemLoad">
            <td style="text-align: center">
              <button
                pButton
                type="button"
                (click)="executeAction(actionItemLoad)"
                class="p-button-outlined p-button-secondary"
                [label]="getActionItemText(actionItemLoad)"
                kbxlStopClickPropagation
              ></button>
            </td>
            <td>
              {{ actionItemLoad.actionItemStatus }}
            </td>
            <td
              class="text-right"
              (mouseenter)="showLinehaulRateOverlay($event, actionItemLoad, true)"
              (mouseleave)="hideLinehaulRateOverlay()"
            >
              <span *ngIf="isShipper">
                {{ actionItemLoad.counterOfferRate + actionItemLoad.fuelRate + actionItemLoad.counterOfferLoadshopFee | currency }}
              </span>
              <span *ngIf="!isShipper">
                {{ actionItemLoad.counterOfferRate + actionItemLoad.fuelRate | currency }}
              </span>
            </td>
            <td
              class="text-right"
              (mouseenter)="showLinehaulRateOverlay($event, actionItemLoad, false)"
              (mouseleave)="hideLinehaulRateOverlay()"
            >
              <span *ngIf="isShipper">
                {{ actionItemLoad.lineHaulRate + actionItemLoad.fuelRate | currency }}
              </span>
              <span *ngIf="!isShipper">
                {{ actionItemLoad.lineHaulRate + actionItemLoad.fuelRate - actionItemLoad.loadshopFee | currency }}
              </span>
            </td>
            <td>
              <span *ngIf="actionItemLoad.counterOfferExpirationDate">
                {{ actionItemLoad.counterOfferExpirationDate + 'z' | date: 'short' }}
              </span>
            </td>
            <td>
              {{ actionItemLoad.equipmentCategoryId }}
            </td>
            <td>
              {{ actionItemLoad.equipmentTypeDisplay }}
            </td>
            <td>
              {{ actionItemLoad.mostRecentOfferUserName | titlecase }}
            </td>
            <td>{{ actionItemLoad.originCity | titlecase }}, {{ actionItemLoad.originState }}</td>
            <td>{{ actionItemLoad.destCity | titlecase }}, {{ actionItemLoad.destState }}</td>
            <td>
              <span *ngIf="actionItemLoad.originEarlyDtTm && actionItemLoad.originEarlyDtTm !== actionItemLoad.originLateDtTm">
                {{ actionItemLoad.originEarlyDtTm | date: 'short' }}
                <br />{{ actionItemLoad.originLateDtTm | date: 'short' }}
              </span>
              <span *ngIf="!actionItemLoad.originEarlyDtTm || actionItemLoad.originEarlyDtTm === actionItemLoad.originLateDtTm">
                {{ actionItemLoad.originLateDtTm | date: 'short' }}
              </span>
            </td>
            <td>
              <span *ngIf="actionItemLoad.destEarlyDtTm && actionItemLoad.destEarlyDtTm !== actionItemLoad.destLateDtTm">
                {{ actionItemLoad.destEarlyDtTm | date: 'short' }}
                <br />{{ actionItemLoad.destLateDtTm | date: 'short' }}
              </span>
              <span *ngIf="!actionItemLoad.destEarlyDtTm || actionItemLoad.destEarlyDtTm === actionItemLoad.destLateDtTm">
                {{ actionItemLoad.destLateDtTm | date: 'short' }}
              </span>
            </td>
            <td>{{ actionItemLoad.referenceLoadDisplay }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="numberOfColumns" style="text-align: center; height: 80px">
              <span *ngIf="loading">Loading...</span>
              <span *ngIf="!loading">No results</span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-panel>
  </div>
  <div class="d-lg-none">
    <div class="loading-indicator" *ngIf="loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
    <h4 *ngIf="!loading && actionItemLoads?.length === 0" class="p-4 text-center">No results</h4>
    <div class="load-item d-flex flex-column" *ngFor="let load of actionItemLoads; let i = index">
      <a (click)="onRowSelect(load)">
        <p-card styleClass="load-grid-card">
          <p-header>
            <div class="d-flex flex-column">
              <div class="d-flex flex-wrap align-items-center">
                <div class="flex-grow-1">
                  <div class="trip-origin">
                    <div class="trip-marker-icon">
                      <fa-icon [icon]="['far', 'circle']" size="md"></fa-icon>
                    </div>
                    <span class="trip-text">{{ load.originCity | titlecase }}, {{ load.originState }}</span>
                  </div>
                  <div class="trip-ellipsis-icon">
                    <fa-icon [icon]="['fas', 'ellipsis-v']" size="md"></fa-icon>
                  </div>
                  <div class="trip-destination">
                    <div class="trip-marker-icon">
                      <fa-icon [icon]="['fas', 'map-marker-alt']" size="md"></fa-icon>
                    </div>
                    <span class="trip-text">{{ load.destCity | titlecase }}, {{ load.destState }}</span>
                  </div>
                </div>
                <div>
                  <p *ngIf="isShipper" class="all-in-rate-value">
                    {{ load.lineHaulRate + load.fuelRate | currency }}
                  </p>
                  <p *ngIf="!isShipper" class="all-in-rate-value">
                    {{ load.lineHaulRate + load.fuelRate - load.loadshopFee | currency }}
                  </p>
                  <p class="all-in-rate-label text-right">Total Rate</p>
                </div>
              </div>
            </div>
          </p-header>
          <div class="d-flex flex-column load-item-detail">
            <div class="d-flex flex-wrap align-items-center">
              <div class="flex-grow-1">
                <span>Shipper’s Order Number</span>
              </div>
              <div>
                <span>{{ load.referenceLoadDisplay }}</span>
              </div>
            </div>
            <div class="d-flex flex-wrap align-items-center">
              <div class="flex-grow-1">
                <span>Pickup</span>
              </div>
              <div>
                <span *ngIf="load.originEarlyDtTm && load.originEarlyDtTm !== load.originLateDtTm">
                  {{ load.originEarlyDtTm | date: 'short' }} - {{ load.originLateDtTm | date: 'short' }}
                </span>
                <span *ngIf="!load.originEarlyDtTm || load.originEarlyDtTm === load.originLateDtTm">
                  {{ load.originLateDtTm | date: 'short' }}
                </span>
              </div>
            </div>
            <div class="d-flex flex-wrap align-items-center">
              <div class="flex-grow-1">
                <span>Delivery</span>
              </div>
              <div>
                <span *ngIf="load.destEarlyDtTm && load.destEarlyDtTm !== load.destLateDtTm">
                  {{ load.destEarlyDtTm | date: 'short' }} - {{ load.destLateDtTm | date: 'short' }}
                </span>
                <span *ngIf="!load.destEarlyDtTm || load.destEarlyDtTm === load.destLateDtTm">
                  {{ load.destLateDtTm | date: 'short' }}
                </span>
              </div>
            </div>
            <div class="d-flex flex-wrap align-items-center">
              <div class="flex-grow-1">
                <span>Distance</span>
              </div>
              <div>
                <span>{{ load.miles }}</span>
              </div>
            </div>
            <div class="d-flex flex-wrap align-items-center">
              <div class="flex-grow-1">
                <span>Equipment</span>
              </div>
              <div>
                <span>{{ load.equipmentCategoryId }} - {{ load.equipmentTypeDisplay }}</span>
              </div>
            </div>
            <div class="d-flex flex-wrap align-items-center py-2">
              <div class="flex-grow-1">
                <span>Counter Offers</span>
              </div>
              <div>
                <button
                  pButton
                  type="button"
                  (click)="executeAction(load)"
                  class="p-button-outlined p-button-secondary"
                  [label]="getActionItemText(load)"
                  kbxlStopClickPropagation
                ></button>
              </div>
            </div>
            <div class="d-flex flex-wrap align-items-center">
              <div class="flex-grow-1">
                <span>Action Item Status</span>
              </div>
              <div>
                <span>{{ load.actionItemStatus }}</span>
              </div>
            </div>
            <div class="d-flex flex-wrap align-items-center">
              <div class="flex-grow-1">
                <span>Counter Offer</span>
              </div>
              <div>
                <span *ngIf="isShipper">
                  {{ load.counterOfferRate + load.fuelRate + load.counterOfferLoadshopFee | currency }}
                </span>
                <span *ngIf="!isShipper">
                  {{ load.counterOfferRate + load.fuelRate | currency }}
                </span>
              </div>
            </div>
            <div class="d-flex flex-wrap align-items-center">
              <div class="flex-grow-1">
                <span>Total Rate</span>
              </div>
              <div>
                <span *ngIf="isShipper">
                  {{ load.lineHaulRate + load.fuelRate | currency }}
                </span>
                <span *ngIf="!isShipper">
                  {{ load.lineHaulRate + load.fuelRate - load.loadshopFee | currency }}
                </span>
              </div>
            </div>
            <div class="d-flex flex-wrap align-items-center">
              <div class="flex-grow-1">
                <span>Expires</span>
              </div>
              <div>
                <span *ngIf="load.counterOfferExpirationDate">
                  {{ load.counterOfferExpirationDate + 'z' | date: 'short' }}
                </span>
              </div>
            </div>
          </div>
        </p-card>
      </a>
    </div>
  </div>
</div>

<kbxl-linehaul-rate-overlay
  [linehaulRateData]="linehaulRateData"
  [showLinehaulOverlay]="showLinehaulOverlay"
  [event]="showLinehaulOverlayEvent"
></kbxl-linehaul-rate-overlay>
